import type { ComputedRef } from 'vue';
import { computed, shallowRef, triggerRef } from 'vue';

const MAX_SCOPES = 8;
const MAX_SCOPE_LENGTH = 128;

export const FIELD_SCOPE_KEY = 'field';
export const FIELD_SCOPE_PREFIX = 'field:';

const scopeByKey = shallowRef(new Map<string, string>());

let fieldOwner: number | null = null;

const invalidateField = (key: string): void => {
    fieldOwner = null;
    if (key === FIELD_SCOPE_KEY) {
        return;
    }
    scopeByKey.value.delete(FIELD_SCOPE_KEY);
};

export const setUiScope = (key: string, value: string | null): void => {
    if (value === null) {
        if (scopeByKey.value.delete(key)) {
            invalidateField(key);
            triggerRef(scopeByKey);
        }
        return;
    }

    const clamped = value.slice(0, MAX_SCOPE_LENGTH);

    if (scopeByKey.value.get(key) === clamped) {
        return;
    }

    scopeByKey.value.set(key, clamped);
    invalidateField(key);
    triggerRef(scopeByKey);
};

export const claimFieldScope = (owner: number, label: string): void => {
    setUiScope(FIELD_SCOPE_KEY, `${FIELD_SCOPE_PREFIX}${label}`);
    fieldOwner = owner;
};

export const releaseFieldScope = (owner: number): void => {
    if (fieldOwner !== owner) {
        return;
    }
    fieldOwner = null;
    setUiScope(FIELD_SCOPE_KEY, null);
};

export const uiScopes: ComputedRef<string[]> = computed(() => [...scopeByKey.value.values()].slice(-MAX_SCOPES));
